import { ILenderForm } from 'validation/lenders/createLenderValidationFactory';
import { ILenderRequest } from './ILenderRequest';
import { convertNullToUndefined } from '../../ui-toolkit/utilities/convertNullToUndefined';

export const convertLenderFormToLenderRequest = (form: ILenderForm): ILenderRequest => ({
  name: form.name,
  address: {
    streetAddress: form.address.streetAddress,
    unit: form.address.unit || null,
    city: form.address.city,
    state: form.address.state,
    zipCode: form.address.zip,
    countyState: null,
  },
  mortgageeClause: convertNullToUndefined(form.mortgageeClause),
  masterEmail: convertNullToUndefined(form.masterEmail),
  wfgId: convertNullToUndefined(form.wfgId),
  bulkRateQualified: form.bulkRateQualified,
  refiPremiumOrReportFee: form.refiPremiumOrReportFee,
  refiDiscountedClosingFee: form.refiDiscountedClosingFee,
  refiPageCounts: {
    lienRelease: convertNullToUndefined(form.refiPageCounts.lienRelease),
    mortgage: convertNullToUndefined(form.refiPageCounts.mortgage),
    deed: convertNullToUndefined(form.refiPageCounts.deed),
    noticeOfSettlement: convertNullToUndefined(form.refiPageCounts.noticeOfSettlement),
    subordinationAgreement: convertNullToUndefined(form.refiPageCounts.subordinationAgreement),
    assignment: convertNullToUndefined(form.refiPageCounts.assignment),
  },
  purchasePageCounts: {
    lienRelease: convertNullToUndefined(form.purchasePageCounts.lienRelease),
    mortgage: convertNullToUndefined(form.purchasePageCounts.mortgage),
    deed: convertNullToUndefined(form.purchasePageCounts.deed),
    noticeOfSettlement: convertNullToUndefined(form.purchasePageCounts.noticeOfSettlement),
    subordinationAgreement: convertNullToUndefined(form.purchasePageCounts.subordinationAgreement),
    assignment: convertNullToUndefined(form.purchasePageCounts.assignment),
  },
  coBranded: form.coBranded,
  logoUrl: convertNullToUndefined(form.logoUrl),
});
